(function($){
  
  var _showMessage = function(elements, className, title, options){
    options = options || {};
    options.duration = options.duration || 5000;
    elements.each(function(){
      var $container = $(this);
      var $message = $container.find(".js-form-message");
      if ($message.length != 0) {
        $message.remove();
      }
      $message = $('<p class="js-form-message '+ className +'">'+ title +'</p>').
        width($container.outerWidth()).
        offset($container.offset());
      $container.prepend($message);
      $message.slideDown();
      setTimeout(function(){
        $message.fadeOut(function(){
          $message.remove();
        });
      }, options.duration);
    });
    return this;
  };
  
  $.fn.showSuccessMessage = function(title, options) {
    return _showMessage(this, "form-saved", title, options);
  };
  
  $.fn.showFailMessage = function(title, options) {
    return _showMessage(this, "form-saved js-form-failed", title, options);
  };
  
})(jQuery);



// WEBPACK FOOTER //
// ./app/javascript/plugins/message.js